// extracted by mini-css-extract-plugin
export var statItem = "_f0-1";
export var statsRow = "_f0-0";